import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';
import { AuthService } from 'app/auth/auth.service';
import * as backInter from 'app/auth/auth-data.model';
@Injectable({
  providedIn: 'root'
})

export class NpsService {

  // private ip = 'http://35.232.140.117:3800';
  idEmpresa:any;
  constructor(
    private httpClient: HttpClient,
    private authService:AuthService
  ) { 
    //let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    //this.idEmpresa = infoUsu.empresaId;
  }


  public insertaCatalogoNps(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.nps.insertaCatalogoNps+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveAbiertasCatalogo/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getLanguajesListNon3(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.forAll.getLanguajesListNon3+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Idiomas/all/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getNps(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.nps.getNps+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/getAbiertas/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public updateTraducciones(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.nps.updateTraducciones+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveTraduccionAbierta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getTraducciones(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.nps.getTraducciones+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/getTraduccionesAbiertas/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  // public saveAbiertas(data){
  //
  //   return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.abiertas.saveAbiertas+this.getCompanyID(),data);
  //   // return this.httpClient.post(this.ip+'/api_empresa/addAbierta/'+this.getCompanyID(),data,
  //   // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  // }

  public updateNps(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.nps.updateNps+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/updateAbierta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  // public deleteAbiertas(data){
  //
  //   return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.abiertas.deleteAbiertas+this.getCompanyID(),data);
  //   // return this.httpClient.post(this.ip+'/api_empresa/deleteAbierta/'+this.getCompanyID(),data,
  //   // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  // }


  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }

  ////////////////OBTIENE EL TOKEN DEL USUARIO EN LINEA
  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }

  /*getStatusNpsMedir(anio: any){
    let datos: any = {productoId: anio,	nps: 1};
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }*/


}
